import { useEffect } from "react";
import { CONTACT } from "@/constants/config";

const PROD_ORIGIN = "https://lavish808bulliezrescuedpaws.org";
const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_bulldog-sanctuary/artifacts/g4vq3c1t_1782224774424.png";

/**
 * Emits schema.org JSON-LD for the nonprofit on the homepage.
 * Uses only verified facts from CONTACT constants — no invented ratings/claims.
 */
export default function OrgJsonLd() {
  useEffect(() => {
    // Parse "39525 Los Alamos Rd Ste C, Murrieta CA 92563"
    const [street, cityStateZip = ""] = CONTACT.address.split(",").map((s) => s.trim());
    const parts = cityStateZip.split(" ");
    const postalCode = parts.pop() || "";
    const region = parts.pop() || "";
    const city = parts.join(" ") || "";

    const data = {
      "@context": "https://schema.org",
      "@type": ["NonprofitOrganization", "AnimalShelter"],
      name: CONTACT.org,
      alternateName: "Lavish 808 Bulliez",
      url: PROD_ORIGIN,
      logo: LOGO_URL,
      image: LOGO_URL,
      description:
        "Hawaiian-inspired 501(c)(3) nonprofit bulldog rescue in Murrieta, California — rescuing, rehabilitating and rehoming bulldogs and bully breeds from Hawaiʻi to the West Coast.",
      slogan: CONTACT.motto,
      telephone: CONTACT.phone,
      email: CONTACT.email,
      address: {
        "@type": "PostalAddress",
        streetAddress: street,
        addressLocality: city,
        addressRegion: region,
        postalCode,
        addressCountry: "US",
      },
      taxID: CONTACT.ein,
      sameAs: [CONTACT.facebook, CONTACT.instagram].filter(Boolean),
    };

    const el = document.createElement("script");
    el.type = "application/ld+json";
    el.id = "org-jsonld";
    el.text = JSON.stringify(data);

    // Remove any previously injected instance to keep single source of truth
    document.getElementById("org-jsonld")?.remove();
    document.head.appendChild(el);

    return () => {
      document.getElementById("org-jsonld")?.remove();
    };
  }, []);

  return null;
}
